import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=5ef8dede&scoped=true"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"
import style0 from "./plan.vue?vue&type=style&index=0&id=5ef8dede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef8dede",
  null
  
)

export default component.exports